import {
    SUPPORT_CHAT_GET_CONVERSATIONS,
    SUPPORT_CHAT_GET_CONVERSATION_MESSAGES,
    SUPPORT_CHAT_SEND_MESSAGE,
    SUPPORT_CHAT_DELETE_CONVERSATION,
    SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS,
    SUPPORT_CHAT_GET_USER_SUBCRIPTION,
    SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS,
    SUPPORT_CHAT_DELETE_SUBSCRIPTION,
    SUPPORT_CHAT_ADD_SUBCRIPTION,
    SUPPORT_CHAT_CHANGE_TICKET_STATUS,
    SUPPORT_CHAT_DELETE_TICKET
} from "../actions/support_chat";

import {
    API_BASE_URL,
    SUPPORT_CHAT_GET_CONVERSATIONS_URL,
    SUPPORT_CHAT_GET_CONVERSATION_MESSAGES_URL,
    SUPPORT_CHAT_SEND_MESSAGE_URL,
    SUPPORT_CHAT_DELETE_CONVERSATION_URL,
    SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS_URL,
    SUPPORT_CHAT_GET_USER_SUBCRIPTION_URL,
    SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS_URL,
    SUPPORT_CHAT_DELETE_SUBSCRIPTION_URL,
    SUPPORT_CHAT_ADD_SUBCRIPTION_URL,
    SUPPORT_CHAT_CHANGE_TICKET_STATUS_URL,
    SUPPORT_CHAT_DELETE_TICKET_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [SUPPORT_CHAT_CHANGE_TICKET_STATUS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_CHANGE_TICKET_STATUS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_DELETE_TICKET]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_DELETE_TICKET_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_DELETE_SUBSCRIPTION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_DELETE_SUBSCRIPTION_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_ADD_SUBCRIPTION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_ADD_SUBCRIPTION_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_GET_USER_SUBCRIPTION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_GET_USER_SUBCRIPTION_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_DELETE_CONVERSATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_DELETE_CONVERSATION_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_GET_CONVERSATIONS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_GET_CONVERSATIONS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_GET_CONVERSATION_MESSAGES]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_GET_CONVERSATION_MESSAGES_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [SUPPORT_CHAT_SEND_MESSAGE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SUPPORT_CHAT_SEND_MESSAGE_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    }
};


export default {
    mutations,
    actions,
    getters,
    state
};